<template>
  <menuNav></menuNav>
  <router-view :key="$route.fullPath" />
  <footerDiv></footerDiv>
</template>

<script>

import menuNav from "@/components/Menu/MainMenu/MainMenu";
import footerDiv from "@/components/AppFooter/AppFooter";


export default {
  name: 'App',
  components: {
    footerDiv,
    menuNav
  }
}
</script>

<style>
#app {
  /*font-family: Roboto, Helvetica, Arial, sans-serif;*/
  font-family: Inter, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@import './assets/styles/style.less';
</style>
